import { ChannelType } from '../../../enums';

export interface ChannelTypeOption {
  id: ChannelType;
  name: string;
}

export const channelTypeOptions: Array<{ id: ChannelType; name: string }> = [
  { id: ChannelType.Scheduled, name: 'Scheduled' },
  { id: ChannelType.Dynamic, name: 'Dynamic' },
  { id: ChannelType.NonstopNews, name: 'Non-Stop Live' },
  { id: ChannelType.Programmed, name: 'Programmed' },
  { id: ChannelType.External, name: 'External' },
];
